<template>
	<section class="flex w-full vh-min flex-col">
		<div class="flex flex-row w-full">
			<div class="left-side w-full flex flex-col">
				<div
					v-if="componente.imagens && componente.imagens.length"
					class="w-full flex flex-row justify-between mb-6 items-center"
				>
					<span class="font-bold"> Preview </span>
				</div>
				<div
					v-else-if="
						componente.imagens && componente.imagens.length === 0 && componente.tipo_id !== 6
					"
					class="empty-box h-full w-full bg-green rounded-default"
				>
					<Empty
						message="Ops! Não existem nenhuma imagem válida para este componente."
						subtitle="Tente adicionar uma imagem."
					/>
				</div>
				<div v-else class="empty-box h-full w-full bg-green rounded-default">
					<Empty
						message="Ops! Nenhum preview disponível por enquanto"
						subtitle="Logo teremos novidades por aqui"
					/>
				</div>
				<Slider
					v-if="componente.imagens && componente.tipo.tipo_id === 1"
					:dots="true"
					:arrows="true"
					:slides="returnValidImages(componente.imagens)"
				/>
				<SliderMini
					v-if="componente.imagens && componente.tipo.tipo_id === 2"
					:slides="returnValidImages(componente.imagens)"
				/>
				<BannerTree
					v-if="componente.imagens && componente.tipo.tipo_id === 3"
					:data="returnValidImages(componente.imagens)"
					:show-title="true"
					cols="3"
					rows="1"
					gap="gap-9"
					:login-required="true"
					:rules="[
						{ col: 'col-span-1', row: 'row-span-1' },
						{ col: 'col-span-1', row: 'row-span-1' },
						{ col: 'col-span-1', row: 'row-span-1' },
					]"
				/>
				<BannerTree
					v-if="componente.imagens && componente.tipo.tipo_id === 4"
					:data="returnValidImages(componente.imagens)"
					:show-title="false"
					cols="1"
					rows="1"
					gap="gap-9"
					:login-required="false"
					:rules="[{ col: 'col-span-1', row: 'row-span-1' }]"
				/>

				<SliderCategorias
					v-if="componente.imagens && componente.tipo.tipo_id === 5"
					:sliders="returnValidImages(componente.imagens)"
				/>
				<BannerTree
					v-if="componente.imagens && componente.tipo.tipo_id === 7"
					:data="returnValidImages(componente.imagens)"
					:show-title="false"
					cols="2"
					rows="1"
					gap="gap-9"
					:login-required="false"
					:rules="[
						{ col: 'col-span-1', row: 'row-span-1' },
						{ col: 'col-span-1', row: 'row-span-1' },
					]"
				/>
			</div>
			<form class="right-side rounded-default p-4 bg-white" @submit="(e) => e.preventDefault()">
				<div class="flex flex-col">
					<label class="label-input" for="descricao">Descrição:</label>
					<input
						v-model="componente.descricao"
						required
						type="text"
						class="input-custom"
						name="descricao"
					/>
				</div>
				<div class="flex flex-col">
					<label class="label-input" for="tipo">Tipo:</label>
					<input
						:value="componente.tipo && componente.tipo.descricao ? componente.tipo.descricao : ''"
						disabled
						type="text"
						class="input-custom"
						name="tipo"
					/>
				</div>
				<div class="flex flex-col">
					<label class="label-input" for="pagina">Página:</label>
					<input
						:value="
							componente.pagina && componente.pagina.descricao ? componente.pagina.descricao : ''
						"
						disabled
						type="text"
						class="input-custom"
						name="pagina"
					/>
				</div>
				<div class="flex flex-col">
					<label class="label-input" for="pagina">Posição:</label>
					<input
						v-model="componente.ordem"
						type="number"
						class="input-custom"
						name="pagina"
						disabled
					/>
				</div>
				<div class="flex flex-col">
					<label class="label-input" for="dtinicio">Data Inicio:</label>
					<input
						v-model="componente.dtinicio"
						type="datetime-local"
						class="input-custom"
						name="dtinicio"
					/>
				</div>

				<div class="flex flex-col">
					<label class="label-input" for="dtfim">Data Fim:</label>
					<input
						v-model="componente.dtfim"
						type="datetime-local"
						class="input-custom"
						name="dtfim"
					/>
				</div>
				<div class="flex flex-col">
					<label class="label-input" for="dtfim">Visualização:</label>
					<select
						v-model="componente.tipo_visualizacao"
						class="select-container"
						title="Selecionar o tipo de visualização"
					>
						<option :value="0">Todos</option>
						<option :value="1">Apenas Logado</option>
						<option :value="2" selected>Apenas Deslogado</option>
					</select>
				</div>
				<div class="flex flex-row mt-5">
					<Button
						width="45%"
						title-color="#ffffff"
						border-radius="4px"
						height="35px"
						font-size="10px"
						background-color="#C70505"
						:is-loading="isFullDetailLoading"
						title="RESETAR"
						:icon="{
							type: 'rotate-ccw',
							size: '14px',
							color: '#FFF',
						}"
						@click="getFullDetailsComponent(componente.componente_id)"
					/>
					<Button
						class="ml-4"
						width="45%"
						title-color="#ffffff"
						border-radius="4px"
						:is-loading="isLoadingUpdateComponent"
						font-size="10px"
						height="35px"
						background-color="#09AF5F"
						title="SALVAR"
						:icon="{
							type: 'save',
							size: '14px',
							color: '#FFF',
						}"
						@click="
							updateComponent({
								componente_id: componente.componente_id,
								descricao: componente.descricao,
								identificador: componente.identificador,
								ordem: componente.ordem,
								dtinicio: componente.dtinicio,
								dtfim: componente.dtfim,
								tipo_visualizacao: componente.tipo_visualizacao,
							})
						"
					/>
				</div>
			</form>
		</div>
		<div
			v-if="componente.tipo_id !== 6 && componente.tipo_id !== 8"
			class="flex flex-row rounded-default box-div"
		>
			<div class="left-side container-imagens">
				<div class="header-container flex flex-row justify-between items-center mb-6">
					<div class="flex flex-col">
						<span class="titulo-box">Imagens</span>
						<span class="dica">
							<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Arraste as imagens
							para reordenar
						</span>
					</div>
					<div class="flex flex-row">
						<Button
							width="150px"
							title-color="#ffffff"
							border-radius="3px"
							height="40px"
							font-size="10px"
							background-color="#FF8800"
							title="ADICIONAR IMAGEM"
							:icon="{
								type: 'image',
								size: '14px',
								color: '#FFF',
							}"
							@click="showModal = !showModal"
						/>
						<Button
							class="ml-4"
							width="150px"
							title-color="#ffffff"
							border-radius="3px"
							font-size="10px"
							height="40px"
							background-color="#09AF5F"
							title="APLICAR ALTERAÇÕES"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
							@click="sendNewImageOrder"
						/>
						<Modal
							v-if="showModal"
							title="Upload Imagem"
							heigth="500px"
							width="50%"
							@closemodal="showModal = !showModal"
						>
							<template v-slot:modalcontent>
								<form
									ref="formUpload"
									class="flex flex-col"
									method="post"
									enctype="multipart/form-data"
									@submit.prevent="submitFile"
								>
									<div>
										<div class="flex flex-col mb-4">
											<label class="input-label" for="titulo">Descrição:</label>
											<input class="input-upload-modal" required type="text" name="titulo" />
										</div>
										<div class="flex flex-col mb-4">
											<label class="input-label" for="link">Link (URL):</label>
											<input class="input-upload-modal" type="text" name="link" />
										</div>
										<div class="flex flex-row mb-6">
											<div class="flex flex-col mr-5 w-1-4">
												<label class="input-label" for="dt_inicio">Data Inicio:</label>
												<input class="input-upload-modal text-sm p-2" required type="datetime-local" name="dt_inicio" />
											</div>
											<div class="flex flex-col w-1-4">
												<label class="input-label" for="dt_fim">Data Fim:</label>
												<input class="input-upload-modal text-sm p-2" required type="datetime-local" name="dt_fim" />
											</div>
                      <div class="flex flex-col ml-5 w-1-2">
                       <label class="input-label" for="dt_fim">Plataformas:</label>
                        <treeselect
                            v-model="platformValue"
                            :multiple="true"
                            :options="platformOptions"
                            placeholder="Selecione uma plataforma"
                            class="platform-select"
                            required
                            />
                    </div>
										</div>
									</div>
									<div class="box-image-upload flex flex-col items-start justify-between">
										<div class="mb-4">Selecione as Imagens:</div>
										<div class="flex flex-row w-full justify-between">
											<input
												id="desktop"
												class="box__file"
												type="file"
												name="desktop"
                        :disabled="disableDesktopUpload"
												@change="getFileData($event, 'D')"
											/>
											<label
												v-if="!previewFiles.desktop.src"
												for="desktop"
												:class="`label-upload desktop flex flex-col items-center justify-center rounded-default ${disableDesktopUpload ? 'disabled' : ''}`"
											>
												<feather
													class="phone mb-4"
													type="monitor"
													name="upload"
													size="60"
													color="#ffffff"
												/>
												<span class="img-text">Desktop</span>
											</label>
											<div
												v-else
												class="desktop flex flex-col items-center justify-center relative rounded-default"
											>
												<div class="trash-icon" @click="clearImageInput('desktop')">
													<feather type="trash-2" name="x" size="16" />
												</div>
												<img :src="previewFiles.desktop.src" class="img-preview rounded-default" />
											</div>
											<input
												id="tablet"
												class="box__file"
												type="file"
												name="tablet"
												@change="getFileData($event, 'T')"
											/>
											<label
												v-if="!previewFiles.tablet.src"
												for="tablet"
												class="label-upload tablet flex flex-col items-center justify-center rounded-default"
											>
												<feather
													class="phone mb-4"
													type="tablet"
													name="upload"
													size="60"
													color="#ffffff"
												/>
												<span class="img-text">Tablet</span>
											</label>
											<div
												v-else
												class="desktop flex flex-col items-center justify-center rounded-default"
											>
												<div class="trash-icon" @click="clearImageInput('tablet')">
													<feather type="trash-2" name="x" size="16" />
												</div>
												<img :src="previewFiles.tablet.src" class="img-preview rounded-default" />
											</div>
											<input
												id="smartphone"
												class="box__file"
												type="file"
												name="smartphone"
												@change="getFileData($event, 'S')"
											/>
											<label
												v-if="!previewFiles.smartphone.src"
												for="smartphone"
												class="label-upload smartphone flex flex-col items-center justify-center rounded-default"
											>
												<feather
													class="phone mb-4"
													type="smartphone"
													name="upload"
													size="60"
													color="#ffffff"
												/>
												<span class="img-text">Smartphone</span>
											</label>
											<div
												v-else
												class="desktop flex flex-col items-center justify-center rounded-default"
											>
												<div class="trash-icon" @click="clearImageInput('smartphone')">
													<feather type="trash-2" name="x" size="16" />
												</div>
												<img
													:src="previewFiles.smartphone.src"
													class="img-preview rounded-default"
												/>
											</div>
										</div>
										<div class="flex flex-row items-center w-full mt-4 justify-center">
											<button
												class="btn-steps next mr-4 flex flex-row items-center justify-center"
												:disabled="uploadLoading"
												@click="(step.step2 = true), (step.step1 = false)"
											>
												<feather
													v-if="!uploadLoading"
													type="upload-cloud"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<div v-else class="loader-icon mr-1" />
												<span>Fazer Upload</span>
											</button>
											<div class="btn-steps back" @click="showModal = !showModal">
												<feather
													type="x"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<span>Cancelar</span>
											</div>
										</div>
									</div>
								</form>
							</template>
						</Modal>
					</div>
				</div>
				<draggable
					v-if="componente.imagens"
					:list="componente.imagens"
					class="list-group flex flex-row flex-wrap justify-between"
					@change="updateImageOrder"
				>
					<div
						v-for="(element, index) of componente.imagens"
						:key="element.imagem_id + Math.random()"
						ref="img-item"
						class="image-draggable item mb-6 flex flex-col items-end relative"
						@click="selectImage(index)"
					>
						<div class="flex absolute show-and-hide">
							<div
								class="container-icon rounded-default flex-row items-center justify-center"
								@click="(showDialog = !showDialog), selectImage(index)"
							>
								<feather type="trash-2" name="x" size="12" class="icon-delete" />
							</div>
						</div>
						<img
							v-if="element.tamanhos.length"
							class="rounded-default relative"
							:src="element.tamanhos[0].nome_img"
							onerror="this.onerror=null;this.src='https://img.dpcnet.com.br/catalogo/imagem_indisponivel.jpg'"
						/>
						<img
							v-else
							class="rounded-default relative"
							src="https://img.dpcnet.com.br/catalogo/imagem_indisponivel.jpg"
						/>
            <div class="platforms-icons flex flex-row items-center absolute left-0">
              <div
                v-for="(platform, index) of element.plataforma"
                :key="index"
                class="flex flex-row items-center justify-center cursor-pointer"
              >
              <svg
              v-if="platform === 'ios-app'"
              width="16px" height="16px" viewBox="0 0 256 315" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid"
>
                  <g>
                      <path d="M213.803394,167.030943 C214.2452,214.609646 255.542482,230.442639 256,230.644727 C255.650812,231.761357 249.401383,253.208293 234.24263,275.361446 C221.138555,294.513969
                       207.538253,313.596333 186.113759,313.991545 C165.062051,314.379442 158.292752,301.507828
                      134.22469,301.507828 C110.163898,301.507828 102.642899,313.596301 82.7151126,314.379442 C62.0350407,315.16201 46.2873831,293.668525 33.0744079,274.586162 C6.07529317,235.552544
                       -14.5576169,164.286328 13.147166,116.18047 C26.9103111,92.2909053 51.5060917,77.1630356
                      78.2026125,76.7751096 C98.5099145,76.3877456 117.677594,90.4371851 130.091705,90.4371851 C142.497945,90.4371851 165.790755,73.5415029 190.277627,76.0228474 C200.528668,76.4495055
                       229.303509,80.1636878 247.780625,107.209389 C246.291825,108.132333 213.44635,127.253405
                      213.803394,167.030988 M174.239142,50.1987033
                      C185.218331,36.9088319 192.607958,18.4081019 190.591988,0 C174.766312,0.636050225 155.629514,10.5457909 144.278109,23.8283506 C134.10507,35.5906758 125.195775,54.4170275
                       127.599657,72.4607932 C145.239231,73.8255433 163.259413,63.4970262 174.239142,50.1987249" fill="#000000"
></path>
                  </g>
              </svg>
              <svg v-if="platform === 'android-app'"
              xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18px" height="18px" fill="#7cb342"
>
              <path fill="#7cb342" d="M12 29c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2V29zM40 29c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2
               2V29zM22 40c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2V40zM30 40c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-1.1.9-2 2-2s2 .9 2 2V40z"
/>
               <path fill="#7cb342" d="M14 18v15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V18H14zM24 8c-6 0-9.7 3.6-10 8h20C33.7 11.6 30 8 24 8zM20 13.6c-.6 0-1-.4-1-1 0-.6.4-1 1-1s1
                .4 1 1C21 13.1 20.6 13.6 20 13.6zM28 13.6c-.6 0-1-.4-1-1 0-.6.4-1 1-1s1 .4 1 1C29 13.1 28.6 13.6 28 13.6z"
/>
                <path fill="#7cb342" d="M28.3 10.5c-.2 0-.4-.1-.6-.2-.5-.3-.6-.9-.3-1.4l1.7-2.5c.3-.5.9-.6 1.4-.3.5.3.6.9.3 1.4l-1.7 2.5C29 10.3 28.7 10.5 28.3
                 10.5zM19.3 10.1c-.3 0-.7-.2-.8-.5l-1.3-2.1c-.3-.5-.2-1.1.3-1.4.5-.3 1.1-.2 1.4.3l1.3 2.1c.3.5.2 1.1-.3 1.4C19.7 10 19.5 10.1 19.3 10.1z"
/>
              </svg>
              <feather
                v-if="platform === 'web'"
                type="globe"
                size="14px"
                name="globe"
                color="#000"
              />
              </div>
            </div>
						<div
							v-if="isExpired(element.dt_fim, element.dt_inicio) === 'expired'"
							class="finish-box flex items-center justify-center"
						>
							<h1>Finalizou dia {{ dateTimeToBrasil(element.dt_fim) }}</h1>
						</div>
						<div
							v-else-if="isExpired(element.dt_fim, element.dt_inicio) === 'not-started'"
							class="init-box flex items-center justify-center"
						>
							<h1>Inicia dia {{ dateTimeToBrasil(element.dt_inicio) }}</h1>
						</div>
					</div>
					<Modal
						v-if="showDialog"
						title="Remover Imagem"
						heigth="500px"
						width="20%"
						@closemodal="showDialog = !showDialog"
					>
						<template v-slot:modalcontent>
							<p class="text-center">Você está prestes a remover uma imagem, tem certeza disso?</p>
							<div class="flex flex-row items-center w-full mt-4 justify-center">
								<button
									class="btn-steps back mr-4 flex flex-row items-center justify-center"
									@click="showDialog = !showDialog"
								>
									<span>Cancelar</span>
								</button>
								<div class="btn-steps next" @click="dialogFunction">
									<span>Remover Imagem</span>
								</div>
							</div>
						</template>
					</Modal>
				</draggable>
			</div>
			<form v-if="imageSelected" class="right-side" @submit="(e) => e.preventDefault()">
				<div class="flex flex-col w-full image-details bg-white p-4 rounded-default">
					<div class="flex flex-col">
						<label class="label-input" for="titulo">Titulo:</label>
						<input v-model="imageSelected.titulo" type="text" class="input-custom" name="titulo" />
					</div>
					<div class="flex flex-col">
						<label class="label-input" for="link">Url:</label>
						<input v-model="imageSelected.link" type="text" class="input-custom" name="link" />
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtinicio">Data Inicio:</label>
						<input
							v-model="imageSelected.dt_inicio"
							type="datetime-local"
							class="input-custom"
							name="dtinicio"
						/>
					</div>
					<div class="flex flex-col">
						<label class="label-input" for="dtfim">Data Fim:</label>
						<input
							v-model="imageSelected.dt_fim"
							type="datetime-local"
							class="input-custom"
							name="dtfim"
						/>
					</div>
          <div class="flex flex-col">
					<label class="label-input" for="dtfim">Plataformas:</label>
					<treeselect
            v-model="imageSelected.plataforma"
            :multiple="true"
            :options="platformOptions"
            placeholder="Selecione uma plataforma"
            class="platform-select"
            required
            />
				</div>

					<div class="flex flex-row mt-5">
						<Button
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							height="35px"
							font-size="10px"
							:is-loading="isFullDetailLoading"
							background-color="#C70505"
							title="RESETAR"
							:icon="{
								type: 'rotate-ccw',
								size: '14px',
								color: '#FFF',
							}"
							@click="getFullDetailsComponent(componente.componente_id)"
						/>
						<Button
							class="ml-4"
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							font-size="10px"
							height="35px"
							background-color="#09AF5F"
							:is-loading="isLoadingUpdateImageDetails"
							title="SALVAR"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
							@click="updateImageDetails(imageSelected, imageSelected.componente_id)"
						/>
					</div>
				</div>

				<div class="flex flex-col bg-white rounded-default image-responsivity mt-4 p-4">
					<span class="label-input font-bold">Arquivos:</span>
					<div
						v-for="(image, index) of imageSelected.tamanhos"
						:key="index"
						class="container-image-responsively flex flex-col"
					>
						<div class="device-label flex flex-row justify-between items-center pb-1">
							{{ `${getImageDesc(image.tipo)}` }}
							<div class="flex flex-row items-center justify-center">
								<label class="label-edit-icon" :for="`input-edit-image-${image.tipo}`">
									<feather type="edit-2" class="edit-icon" size="12px" />
								</label>
								<input
									:id="`input-edit-image-${image.tipo}`"
									:name="`input-edit-image-${image.tipo}`"
									:class="`input-edit-image-${image.tipo}`"
									type="file"
									@change="onFileChange($event, image)"
								/>

								<feather
									id="delete-image"
									type="trash-2"
									class="edit-icon"
									size="12px"
									@click="deleteImageDevice(image.componente_imagem_tam_id)"
								/>
							</div>
						</div>
						<img :src="image.nome_img" alt="" />
					</div>
				</div>
			</form>
		</div>
		<div
			v-else-if="componente.tipo_id === 6 && componente.isblocked"
			class="flex flex-row rounded-default box-div"
		>
			<div class="left-side container-imagens">
				<div class="header-container flex flex-row justify-between items-center mb-6">
					<div class="flex flex-col">
						<span class="titulo-box">Produtos</span>
					</div>
					<div>
						<span class="dica alert">
							<font-awesome-icon size="sm" color="#dfa108" icon="lightbulb" />
							Este tipo de componente não permite a adição/alteração nos produtos
						</span>
					</div>
				</div>
				<div>
					<Table
						style-class="vgt-table striped"
						:columns="[
							{
								label: 'Produto Id',
								field: 'produto_id',
								type: 'string',
							},
							{
								label: 'Ordem',
								field: 'ordem',
								type: 'string',
							},
							{
								label: 'Data Inicio',
								field: 'dt_inicio',
								type: 'date',
								dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
								dateOutputFormat: 'dd/MM/yyyy',
							},
							{
								label: 'Data Fim',
								field: 'dt_fim',
								type: 'date',
								dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
								dateOutputFormat: 'dd/MM/yyyy',
							},
						]"
						:rows="componente.produtos"
						:compact-mode="true"
						@on-row-click="/*onRowClick($event)*/"
					/>
				</div>
			</div>
			<form
				v-if="!isEmptyObject(productSelected)"
				class="right-side"
				@submit="(e) => e.preventDefault()"
			>
				<div class="flex flex-col w-full image-details bg-white p-4 rounded-default">
					<div class="flex flex-col">
						<label class="label-input" for="titulo">Produto Id:</label>
						<input
							v-model="productSelected.produto_id"
							type="text"
							disabled
							class="input-custom"
							name="titulo"
						/>
					</div>
					<div class="flex flex-col">
						<label class="label-input" for="link">Ordem:</label>
						<input v-model="productSelected.ordem" type="number" class="input-custom" name="link" />
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtinicio">Data Inicio:</label>
						<input
							v-model="productSelected.dt_inicio"
							type="datetime-local"
							class="input-custom"
							name="dtinicio"
						/>
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtfim">Data Fim:</label>
						<input
							v-model="productSelected.dt_fim"
							type="datetime-local"
							class="input-custom"
							name="dtfim"
						/>
					</div>
					<div class="flex flex-row mt-5">
						<Button
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							height="35px"
							:is-loading="isFullDetailLoading"
							font-size="10px"
							background-color="#C70505"
							title="RESETAR"
							:icon="{
								type: 'rotate-ccw',
								size: '14px',
								color: '#FFF',
							}"
							@click="getFullDetailsComponent(componente.componente_id)"
						/>
						<Button
							class="ml-4"
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							font-size="10px"
							height="35px"
							background-color="#09AF5F"
							title="SALVAR"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
							@click="updateProductDetails(productSelected, productSelected.componente_id)"
						/>
					</div>
				</div>
			</form>
		</div>
		<div v-else-if="componente.tipo_id === 6" class="flex flex-row rounded-default box-div">
			<div class="left-side container-imagens">
				<div class="header-container flex flex-row justify-between items-center mb-6">
					<div class="flex flex-col">
						<span class="titulo-box">Produtos</span>
						<span class="dica">
							<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Clique no ícone da
							lixeira para remover o produto do componente
						</span>
					</div>
					<div class="flex flex-row">
						<div>
							<Button
								width="150px"
								title-color="#ffffff"
								border-radius="3px"
								height="40px"
								font-size="10px"
								background-color="rgb(0 142 255)"
								title="IMPORTAR PRODUTOS"
								:icon="{
									type: 'file-plus',
									size: '14px',
									color: '#FFF',
								}"
								@click="importProdutoModal = !importProdutoModal"
							/>
							<Modal
								v-if="importProdutoModal"
								title="Importar Produtos"
								width="500px"
								@closemodal="
									importProdutoModal = !importProdutoModal;
									cleanOnCloseModal();
								"
							>
								<template v-slot:modalcontent>
									<form
										ref="formUpload"
										class="flex flex-col items-center justify-center"
										method="post"
										enctype="multipart/form-data"
										@submit.prevent="addProdutoComponente"
									>
										<div
											v-if="sheetsFound.length"
											class="fileAddButton flex flex-col items-center justify-center"
										>
											<input
												id="fileProducts"
												type="file"
												style="display: none"
												@change="(e) => handleImportFile(e)"
											/>
											<label for="fileProducts">
												<feather
													type="plus"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												Selecionar arquivo
											</label>
										</div>
										<div
											v-if="sheetsFound.length"
											class="flex items-center justify-center flex-col w-100 m-1"
										>
											<!--<span class="dica m-1">
												Atenção!, os produtos abaixo serão importados para o componente
											</span>-->
											<form class="w-100" @submit.prevent="handleAddProductsImported">
												<div class="w-100">
													<!--<Table
														style-class="vgt-table striped "
														:columns="[
															{
																label: 'Produto Id',
																field: 'produtoId',
																type: 'string',
															},
														]"
														:rows="productsImported"
														:compact-mode="true"
														:maxHeight="'200px'"
														:fixedHeader="true"
														@on-row-click="onRowClick($event)"
														@on-row-delete="onRowDelete($event)"
													/>-->
													<div v-if="sheetsFound" class="d-flex justify-center is-wrapped gap-1">
														<div
															v-for="(sheet, index) in sheetsFound"
															:key="index"
															class="sheetContent"
															:class="{ selected: sheetsSelected.includes(index + 1) }"
														>
															<input
																:id="index"
																:name="index"
																type="checkbox"
																@change="handleSelectSheetName(index + 1)"
															/>
															<label :for="index">{{
																'#' + (index + 1) + '  ' + sheet.name.toLowerCase()
															}}</label>
														</div>
													</div>
													<div class="flex flex-row mb-4 mt-4 input-group-custom">
														<div class="flex flex-col input-group-item">
															<label class="input-label" for="dt_inicio">Data Inicio:</label>
															<input
																v-model="addProdutoData.dt_inicio"
																type="date"
																name="dt_inicio"
																class="input-custom"
															/>
														</div>
														<div class="flex flex-col input-group-item">
															<label class="input-label" for="dt_fim">Data Fim:</label>
															<input
																v-model="addProdutoData.dt_fim"
																class="input-custom"
																type="date"
																name="dt_fim"
															/>
														</div>
														<div class="flex flex-col input-group-item">
															<label class="input-label" for="dt_fim">Ordem:</label>
															<input
																v-model="addProdutoData.ordem"
																class="input-custom"
																required
																type="number"
																name="dt_fim"
																min="0"
															/>
														</div>
													</div>
												</div>
												<div class="flex justify-center">
													<Button
														width="150px"
														title-color="#ffffff"
														border-radius="3px"
														height="40px"
														font-size="10px"
														background-color="#C70505"
														title="Cancelar"
														:icon="{
															type: 'x',
															size: '14px',
															color: '#FFF',
														}"
														@click="
															importProdutoModal = !importProdutoModal;
															cleanOnCloseModal();
														"
													/>
													<Button
														width="150px"
														title-color="#ffffff"
														border-radius="3px"
														margin-left="10px"
														height="40px"
														font-size="10px"
														background-color="#09AF5F"
														title="Importar"
														:icon="{
															type: 'save',
															size: '14px',
															color: '#FFF',
														}"
													/>
												</div>
											</form>
										</div>
										<div v-else class="flex flex-col justify-center items-center">
											<span class="dica alert text-center">
												<p class="text-center"><b>Atenção!</b></p>
												Produtos irão ser importados a partir das colunas "ean" ou "cod_produto"
												<br />
												Arquivos permitidos: ".xlsx"
											</span>
										</div>
									</form>
									<div
										v-if="!sheetsFound.length"
										class="fileAddButton flex flex-col items-center justify-center"
									>
										<input
											id="fileProducts"
											type="file"
											style="display: none"
											@change="(e) => handleImportFile(e)"
										/>
										<label for="fileProducts">
											<feather
												type="plus"
												class="mr-1"
												name="arrow-right"
												size="14"
												color="#ffffff"
											/>
											Selecionar arquivo
										</label>
									</div>
								</template>
							</Modal>
						</div>
						<div>
							<Button
								width="150px"
								title-color="#ffffff"
								border-radius="3px"
								height="40px"
								font-size="10px"
								margin-left="10px"
								background-color="#FF8800"
								title="ADICIONAR PRODUTOS"
								:icon="{
									type: 'image',
									size: '14px',
									color: '#FFF',
								}"
								@click="addProdutoModal = !addProdutoModal"
							/>

							<!-- MODAL ADICIONAR PRODUTO  -->
							<Modal
								v-if="addProdutoModal"
								title="Adicionar Produto"
								width="calc(100% - 100px)"
								max-width="1500px"
								@closemodal="addProdutoModal = !addProdutoModal"
							>
								<template v-slot:modalcontent>
									<form
										ref="formUpload"
										class="flex flex-col"
										method="post"
										enctype="multipart/form-data"
										@submit.prevent="onSearchProduct"
									>
										<Search
											width="100%"
											:bordered="true"
											height="35px"
											:disabled="searchProductLoading"
											@searchtext="($event) => (searchProductText = $event)"
										/>
									</form>
									<template v-if="searchProdutos.length > 0 && !searchProductLoading">
										<input
											id="add-all-products"
											v-model="allProductsChecked"
											type="checkbox"
											@click="toggleCheckAllProducts(allProductsChecked)"
										/>
										<label for="add-all-products">
											<small v-if="!allProductsChecked"> Marcar todos</small>
											<small v-else> Desmarcar todos</small>
										</label>
									</template>
									<div>
										<div class="flex flex-col mb-4">
											<div class="container-produto">
												<div v-if="searchProductLoading">Carregando produtos...</div>
												<div v-if="searchProdutos.length <= 0 && !searchProductLoading">
													Digite e pressione enter para pesquisar...
												</div>

												<div
													v-for="(produto, index) of searchProdutos"
													:key="index"
													class="produto-item flex flex-col"
													:class="{
														selected: addProdutoData.produto_id.includes(produto.integracao_id),
													}"
													@click="selectProduto(produto)"
												>
													<input
														type="checkbox"
														:checked="addProdutoData.produto_id.includes(produto.integracao_id)"
													/>
													<div class="produto-imagem">
														<img :src="produto.src" alt="" loading="lazy" />
													</div>

													<span class="descricao">{{ produto.descricao }}</span>

													<div class="produto-info">
														<span>Cod: {{ produto.integracao_id }}</span>
														<span v-if="produto.ean">Ean: {{ produto.ean }}</span>
													</div>
												</div>
											</div>
										</div>
										<div class="flex flex-row mb-4 input-group-custom">
											<div class="flex flex-col input-group-item">
												<label class="input-label" for="dt_inicio">Data Inicio:</label>
												<input
													v-model="addProdutoData.dt_inicio"
													type="date"
													name="dt_inicio"
													class="input-custom"
												/>
											</div>
											<div class="flex flex-col input-group-item">
												<label class="input-label" for="dt_fim">Data Fim:</label>
												<input
													v-model="addProdutoData.dt_fim"
													class="input-custom"
													type="date"
													name="dt_fim"
												/>
											</div>
											<div class="flex flex-col input-group-item">
												<label class="input-label" for="dt_fim">Ordem:</label>
												<input
													v-model="addProdutoData.ordem"
													class="input-custom"
													required
													type="number"
													name="dt_fim"
												/>
											</div>
										</div>
										<div
											class="flex flex-row items-center w-full mt-8 justify-center"
											style="justify-content: flex-end"
										>
											<button class="btn-produto back" @click="addProdutoModal = !addProdutoModal">
												<feather
													type="x"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<span>Cancelar</span>
											</button>

											<button
												class="btn-produto next ml-4 flex flex-row items-center justify-center"
												@click="addProdutoComponente"
											>
												<feather
													type="save"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<span>Adicionar Produto</span>
											</button>
										</div>
									</div>
								</template>
							</Modal>
						</div>
					</div>
				</div>
				<div>
					<Table
						style-class="vgt-table striped"
						:columns="tableCols"
						:rows="componente.produtos"
						:compact-mode="true"
						:sort-options="{
							enabled: true,
							initialSortBy: { field: 'ordem', type: 'asc' },
						}"
						@on-row-click="onRowClick($event)"
						@on-row-delete="onRowDelete($event)"
					/>
					<Modal
						v-if="deleteDialog"
						title="Remover Produto"
						heigth="500px"
						width="20%"
						@closemodal="deleteDialog = !deleteDialog"
					>
						<template v-slot:modalcontent>
							<p class="text-center">
								Você está prestes a remover o produto do componente, tem certeza disso?
							</p>
							<div class="flex flex-row items-center w-full mt-4 justify-center">
								<button
									class="btn-steps back mr-4 flex flex-row items-center justify-center"
									@click="deleteDialog = !deleteDialog"
								>
									<span>Cancelar</span>
								</button>
								<div class="btn-steps next" @click="deleteDialogFunction">
									<span>Remover Produto</span>
								</div>
							</div>
						</template>
					</Modal>
				</div>
			</div>
			<form
				v-if="!isEmptyObject(productSelected)"
				class="right-side"
				@submit="(e) => e.preventDefault()"
			>
				<div class="flex flex-col w-full image-details bg-white p-4 rounded-default">
					<div class="flex flex-col">
						<label class="label-input" for="titulo">Produto:</label>
						<input
							v-model="productSelected.produto.descricao"
							type="text"
							disabled
							class="input-custom"
							name="titulo"
						/>
					</div>
					<div class="flex flex-col">
						<label class="label-input" for="link">Ordem:</label>
						<input v-model="productSelected.ordem" type="number" class="input-custom" name="link" />
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtinicio">Data Inicio:</label>
						<input
							v-model="productSelected.dt_inicio"
							type="datetime-local"
							class="input-custom"
							name="dtinicio"
						/>
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtfim">Data Fim:</label>
						<input
							v-model="productSelected.dt_fim"
							type="datetime-local"
							class="input-custom"
							name="dtfim"
						/>
					</div>
					<div class="flex flex-row mt-5">
						<Button
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							height="35px"
							:is-loading="isFullDetailLoading"
							font-size="10px"
							background-color="#C70505"
							title="RESETAR"
							:icon="{
								type: 'rotate-ccw',
								size: '14px',
								color: '#FFF',
							}"
							@click="getFullDetailsComponent(componente.componente_id)"
						/>
						<Button
							class="ml-4"
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							font-size="10px"
							height="35px"
							background-color="#09AF5F"
							title="SALVAR"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
							@click="updateProductDetails(productSelected, productSelected.componente_id)"
						/>
					</div>
				</div>
			</form>
		</div>
		<div v-if="componente.tipo_id === 8" class="flex flex-row rounded-default box-div">
			<div class="left-side container-imagens">
				<div class="header-container flex flex-row justify-between items-center mb-6">
					<div class="flex flex-col">
						<span class="titulo-box">Categorias</span>
						<span class="dica">
							<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Clique no ícone da
							lixeira para remover a categoria do componente
						</span>
					</div>
					<div class="flex flex-row">
						<div>
							<Button
								width="180px"
								title-color="#ffffff"
								border-radius="3px"
								height="40px"
								font-size="10px"
								margin-left="10px"
								background-color="#FF8800"
								title="ADICIONAR CATEGORIAS"
								:icon="{
									type: 'image',
									size: '14px',
									color: '#FFF',
								}"
								@click="addCategoriaModal = !addCategoriaModal"
							/>
							<Modal
								v-if="addCategoriaModal"
								title="Adicionar Categoria"
								width="850px"
								@closemodal="addCategoriaModal = !addCategoriaModal"
								@created="onSearchCategoria()"
							>
								<template v-slot:modalcontent>
									<form
										ref="formUpload"
										class="flex flex-col"
										method="post"
										enctype="multipart/form-data"
										@submit.prevent="onSearchCategoria"
									>
										<Search
											width="100%"
											:bordered="true"
											height="35px"
											@searchtext="($event) => (searchCategoriaText = $event)"
										/>
									</form>
									<div>
										<div class="flex flex-col mb-4">
											<div class="container-produto">
												<div
													v-for="(categoria, index) of componenteCategoriasFiltered"
													:key="index"
													class="produto-item flex flex-col"
													:class="{
														selected: addCategoriaData.categoria_id.includes(categoria.id),
													}"
													@click="selectCategoria(categoria)"
												>
													<input
														type="checkbox"
														:checked="addCategoriaData.categoria_id.includes(categoria.id)"
													/>
													<span class="descricao">{{ categoria.descricao }}</span>

													<!-- <div class="produto-info">
														<span>Cod: {{ categoria.id }}</span>
														<span>Ean: {{ categoria.ean }}</span>
													</div> -->
												</div>
											</div>
										</div>
										<div class="flex flex-row mb-4 input-group-custom">
											<div class="flex flex-col input-group-item">
												<label class="input-label" for="dt_inicio">Data Inicio:</label>
												<input
													v-model="addCategoriaData.dt_inicio"
													type="date"
													name="dt_inicio"
													class="input-custom"
												/>
											</div>
											<div class="flex flex-col input-group-item">
												<label class="input-label" for="dt_fim">Data Fim:</label>
												<input
													v-model="addCategoriaData.dt_fim"
													class="input-custom"
													type="date"
													name="dt_fim"
												/>
											</div>
											<!-- <div class="flex flex-col input-group-item">
												<label class="input-label" for="dt_fim">Ordem:</label>
												<input
													v-model="addCategoriaData.ordem"
													class="input-custom"
													required
													type="number"
													name="dt_fim"
												/>
											</div> -->
										</div>
										<div class="flex flex-row items-center w-full mt-8 justify-center">
											<button
												class="btn-produto back"
												@click="addCategoriaModal = !addCategoriaModal"
											>
												<feather
													type="x"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<span>Cancelar</span>
											</button>

											<button
												class="btn-produto next ml-4 flex flex-row items-center justify-center"
												:disabled="isLoadingAdicionarCategoria"
												@click="addCategoriaComponente"
											>
												<feather
													v-if="!isLoadingAdicionarCategoria"
													type="save"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<div v-else class="loader-icon mr-1" />
												<span>Adicionar Categoria</span>
											</button>
										</div>
									</div>
								</template>
							</Modal>
						</div>
					</div>
				</div>

				<draggable-table
					:columns="[
						{
							label: 'Descrição',
							field: 'categoria.descricao',
							type: 'string',
						},
						{
							label: 'Data Inicio',
							field: 'dt_inicio',
							type: 'date',
							dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
							dateOutputFormat: 'dd/MM/yyyy',
						},
						{
							label: 'Data Fim',
							field: 'dt_fim',
							type: 'date',
							dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
							dateOutputFormat: 'dd/MM/yyyy',
						},
						{
							label: 'Ações',
							field: 'acoes',
						},
					]"
					:rows="componente.componente_categorias"
					@on-row-click="onRowClick($event)"
					@on-row-delete="onRowDelete($event)"
					@drag-end="updateCategoriaOrder"
				>
					<template slot="table-row" slot-scope="props">
						<span
							v-if="props.column.field == 'acoes'"
							class="edit-box"
							@click="onRowDelete(props.row)"
						>
							<feather class="edit-icon" :type="'trash-2'" size="18" />
						</span>
					</template>
				</draggable-table>

				<div>
					<!-- <Table
						style-class="vgt-table striped"
						:columns="[
							{
								label: 'Descrição',
								field: 'categoria.descricao',
								type: 'string',
							},
							{
								label: 'Ordem',
								field: 'ordem',
								type: 'string',
							},
							{
								label: 'Data Inicio',
								field: 'dt_inicio',
								type: 'date',
								dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
								dateOutputFormat: 'dd/MM/yyyy',
							},
							{
								label: 'Data Fim',
								field: 'dt_fim',
								type: 'date',
								dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
								dateOutputFormat: 'dd/MM/yyyy',
							},
							{
								label: 'Ações',
								field: 'acoes',
								type: 'string',
								tdClass: 'text-center',
								thClass: 'text-center',
							},
						]"
						:rows="componente.componente_categorias"
						:compact-mode="true"
						:sort-options="{
							enabled: true,
							initialSortBy: { field: 'ordem', type: 'asc' },
						}"
						@on-row-click="onRowClick($event)"
						@on-row-delete="onRowDelete($event)"
					/> -->
					<Modal
						v-if="deleteDialog"
						title="Remover Categoria"
						heigth="500px"
						width="20%"
						@closemodal="deleteDialog = !deleteDialog"
					>
						<template v-slot:modalcontent>
							<p class="text-center">
								Você está prestes a remover a categoria do componente, tem certeza disso?
							</p>
							<div class="flex flex-row items-center w-full mt-4 justify-center">
								<button
									class="btn-steps back mr-4 flex flex-row items-center justify-center"
									@click="deleteDialog = !deleteDialog"
								>
									<span>Cancelar</span>
								</button>
								<div class="btn-steps next" @click="deleteDialogFunction">
									<span>Remover Categoria</span>
								</div>
							</div>
						</template>
					</Modal>
				</div>
			</div>
			<form
				v-if="!isEmptyObject(productSelected)"
				class="right-side"
				@submit="(e) => e.preventDefault()"
			>
				<div class="flex flex-col w-full image-details bg-white p-4 rounded-default">
					<div class="flex flex-col">
						<label class="label-input" for="titulo">Produto Id:</label>
						<input
							v-model="productSelected.produto_id"
							type="text"
							disabled
							class="input-custom"
							name="titulo"
						/>
					</div>
					<div class="flex flex-col">
						<label class="label-input" for="link">Ordem:</label>
						<input v-model="productSelected.ordem" type="number" class="input-custom" name="link" />
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtinicio">Data Inicio:</label>
						<input
							v-model="productSelected.dt_inicio"
							type="datetime-local"
							class="input-custom"
							name="dtinicio"
						/>
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtfim">Data Fim:</label>
						<input
							v-model="productSelected.dt_fim"
							type="datetime-local"
							class="input-custom"
							name="dtfim"
						/>
					</div>
					<div class="flex flex-row mt-5">
						<Button
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							height="35px"
							:is-loading="isFullDetailLoading"
							font-size="10px"
							background-color="#C70505"
							title="RESETAR"
							:icon="{
								type: 'rotate-ccw',
								size: '14px',
								color: '#FFF',
							}"
							@click="getFullDetailsComponent(componente.componente_id)"
						/>
						<Button
							class="ml-4"
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							font-size="10px"
							height="35px"
							background-color="#09AF5F"
							title="SALVAR"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
							@click="updateProductDetails(productSelected, productSelected.componente_id)"
						/>
					</div>
				</div>
			</form>
			<form
				v-if="!isEmptyObject(categoriaSelected)"
				class="right-side"
				@submit="(e) => e.preventDefault()"
			>
				<div class="flex flex-col w-full image-details bg-white p-4 rounded-default">
					<div class="flex flex-col">
						<label class="label-input" for="categoria">Categoria:</label>
						<select id="" v-model="categoriaSelected.categoria_id" name="categoria">
							<option
								v-for="option in componenteCategoriasFiltered"
								:key="option.id"
								:value="option.id"
								:selected="option.id == categoriaSelected.categoria_id"
							>
								{{ option.descricao }}
							</option>
						</select>
					</div>
					<!-- <div class="flex flex-col">
						<label class="label-input" for="link">Ordem:</label>

						<select v-model="categoriaSelected.ordem" class="input-custom">
							<option
								v-for="(categoria, index) in componente.componente_categorias"
								:key="index"
								:value="categoria.ordem"
							>
								{{ categoria.ordem }}
							</option>
						</select>
					</div> -->

					<div class="flex flex-col">
						<label class="label-input" for="dtinicio">Data Inicio:</label>
						<input
							v-model="categoriaSelected.dt_inicio"
							type="datetime-local"
							class="input-custom"
							name="dtinicio"
						/>
					</div>

					<div class="flex flex-col">
						<label class="label-input" for="dtfim">Data Fim:</label>
						<input
							v-model="categoriaSelected.dt_fim"
							type="datetime-local"
							class="input-custom"
							name="dtfim"
						/>
					</div>
					<div class="flex flex-row mt-5">
						<Button
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							height="35px"
							:is-loading="isFullDetailLoading"
							font-size="10px"
							background-color="#C70505"
							title="RESETAR"
							:icon="{
								type: 'rotate-ccw',
								size: '14px',
								color: '#FFF',
							}"
							@click="rowSelected = {}"
						/>
						<Button
							class="ml-4"
							width="45%"
							title-color="#ffffff"
							border-radius="4px"
							font-size="10px"
							height="35px"
							background-color="#09AF5F"
							title="SALVAR"
							:icon="{
								type: 'save',
								size: '14px',
								color: '#FFF',
							}"
							@click="updateCategoriaDetails(categoriaSelected, categoriaSelected.componente_id)"
						/>
					</div>
				</div>
			</form>
		</div>
	</section>
</template>

<script>
// eslint-disable-next-line import/extensions
import Button from '@/layout/components/buttons/Default.vue';
// eslint-disable-next-line import/extensions
import Slider from '@/layout/components/slider/slider.vue';
import draggable from 'vuedraggable';
import BannerTree from '@/layout/components/banner/tree';
import * as ecAxios from '@/util/ecAxios';
// eslint-disable-next-line import/extensions
import Modal from '@/layout/components/modal/centered.vue';
// eslint-disable-next-line import/extensions
import SliderMini from '@/layout/components/slider/sliderMini.vue';
// eslint-disable-next-line import/extensions
import SliderCategorias from '@/layout/components/slider/sliderCategorias.vue';
// eslint-disable-next-line import/extensions
import Empty from '@/layout/components/empty';
// eslint-disable-next-line import/extensions
import Global from '@/mixins/global';
// eslint-disable-next-line import/extensions
import Table from '@/layout/components/table/vuegoodtable.vue';
import Search from '@/layout/components/search/new';
import readXlsxFile from 'read-excel-file';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import DraggableTable from '@/layout/components/table/draggableTable';

export default {
	name: 'ComponentEdit',
	components: {
		Button,
		BannerTree,
		Search,
		Slider,
		draggable,
		Modal,
		SliderCategorias,
		SliderMini,
		Empty,
		Table,
		DraggableTable,
    Treeselect
	},
	mixins: [Global],
	data() {
		return {
			searchProductLoading: false,
			allProductsChecked: false,
			step: {
				step1: false,
				step2: true,
			},
      platformValue: ['web', 'android-app', 'ios-app'],
      platformOptions: [{
        id: 'web',
        label: 'Web',
        }, {
        id: 'mobile',
        label: 'App Mobile',
        children: [{
            id: 'android-app',
            label: 'Android',
        }, {
            id: 'ios-app',
            label: 'IOS',
        }],
        }],
			isFullDetailLoading: false,
      disableDesktopUpload: false,
			updateProductDetailsLoading: false,
			isLoadingUpdateComponent: false,
			isLoadingUpdateImageDetails: false,
			isLoadingAdicionarCategoria: false,
			sendNewImageOrderLoading: false,
			deleteDialog: false,
			addProdutoModal: false,
			addCategoriaModal: false,
			addProdutoData: {
				produto_id: [],
				dt_inicio: '',
				dt_fim: '',
				ordem: 1,
				tipo_visualizacao: 0,
			},
			addCategoriaData: {
				categoria_id: [],
				dt_inicio: '',
				dt_fim: '',
				ordem: 1,
				tipo_visualizacao: 0,
			},
			tableCols: [
				{
					label: 'Descrição',
					field: 'produto.descricao',
					type: 'string',
				},
				{
					label: 'Ordem',
					field: 'ordem',
					type: 'string',
				},
				{
					label: 'Data Inicio',
					field: 'dt_inicio',
					type: 'date',
					dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
					dateOutputFormat: 'dd/MM/yyyy',
				},
				{
					label: 'Data Fim',
					field: 'dt_fim',
					type: 'date',
					dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
					dateOutputFormat: 'dd/MM/yyyy',
				},
				{
					label: 'Ações',
					field: 'acoes',
					type: 'string',
					tdClass: 'text-center',
					thClass: 'text-center',
				},
			],
			componente: [],
			selectedFiles: [],
			preparedDeleteData: {},
			allViews: [],
			rowSelected: {},
			dragging: false,
			showDialog: false,
			uploadLoading: false,
			newImageOrder: [],
			searchProdutos: [],
			searchCategorias: [],
			imageSelected: null,
			errorToastOptions: {
				position: 'bottom-right',
				timeout: 5000,
				closeOnClick: true,
				pauseOnFocusLoss: true,
				pauseOnHover: true,
				draggable: true,
				draggablePercent: 0.6,
				showCloseButtonOnHover: false,
				hideProgressBar: true,
				closeButton: 'button',
				icon: true,
				rtl: false,
			},
			previewFiles: {
				desktop: {
					src: null,
					name: null,
					size: null,
				},

				tablet: {
					src: null,
					name: null,
					size: null,
				},
				smartphone: {
					src: null,
					name: null,
					size: null,
				},
			},
			showModal: false,

			importProdutoModal: false,
			importCategoriaModal: false,
			productsImported: [],
			categoriesImported: [],
			searchProductText: '',
			sheetsFound: [],
			sheetsSelected: [],
			activeSheet: {},
		};
	},
	computed: {
		componenteCategoriasFiltered() {
			if (this.componente && this.componente.componente_categorias) {
				return this.searchCategorias.filter(
					(o1) => !this.componente.componente_categorias.some((o2) => o1.id === o2.categoria_id)
				);
			}
			return this.searchCategorias;
		},
		productSelected() {
			if (this.rowSelected.produto !== undefined) {
				return this.rowSelected;
			}
			return {};
		},
		categoriaSelected() {
			// if (this.rowSelected.categoria !== undefined) {
			// 	return this.rowSelected;
			// }
			// return {};

			if (
				!this.rowSelected.categoria_id ||
				!this.componente ||
				!this.componente.componente_categorias.length
			) {
				return {};
			}

			return this.componente.componente_categorias.find(
				(x) => x.categoria_id === this.rowSelected.categoria_id
			);
		},
	},
  watch: {
    platformValue: {
      handler(val) {
        if (val.length > 0 && !val.includes('web')) {
          this.disableDesktopUpload = true;
        } else {
          this.disableDesktopUpload = false;
        }
      },
      deep: true,
    },
  },
	created() {
		this.onSearchCategoria();
		const componentId = this.$route.params.id;
		if (componentId) {
			this.getFullDetailsComponent(componentId);
		}
	},
	methods: {
		updateCategoriaOrder() {
			this.updateCategoriaDetails(null, this.componente.componente_id);
		},
		deleteDialogFunction(data) {
			if (data.action === 0) {
				this.deleteDialog = !this.deleteDialog;
			} else if (this.componente.tipo_id === 8) {
				this.deleteDialog = !this.deleteDialog;
				this.deleteCategoriaComponent(this.preparedDeleteData);
			} else if (this.componente.tipo_id === 6) {
				this.deleteDialog = !this.deleteDialog;
				this.deleteProductComponent(this.preparedDeleteData);
			}
			this.preparedDeleteData = {};
		},
		onRowDelete(row) {
			this.rowSelected = {};

			this.deleteDialog = !this.deleteDialog;
			this.preparedDeleteData = row;
		},
		async deleteProductComponent(row) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_PRODUTO_DELETE}/${row.componente_id}/${row.produto_id}`;
				const { data } = await ecAxios.connection().delete(url);

				if (!data.error) {
					this.$toast.success(data.message, this.errorToastOptions);
					this.getFullDetailsComponent(row.componente_id);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		async deleteCategoriaComponent(row) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_CATEGORIA_DELETE}/${row.componente_id}/${row.categoria_id}`;
				const { data } = await ecAxios.connection().delete(url);

				if (!data.error) {
					this.$toast.success(data.message, this.errorToastOptions);
					this.getFullDetailsComponent(row.componente_id);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		onFileChange(event, image) {
			const files = event.target.files || event.dataTransfer.files;
			if (!files.length) {
				return;
			}
			this.sendNewFile(files[0], image);
		},
		async sendNewFile(file, image) {
			const formData = new FormData();
			const componentId = this.$route.params.id;
			formData.append('binary', file || null);
			formData.append('componente_id', componentId);
			formData.append('componente_imagem_tam_id', image.componente_imagem_tam_id);
			formData.append('imagem_id', image.imagem_id);
			formData.append('tipo', image.tipo);

			const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_IMAGEM_TAMANHO_UPDATE}`;

			try {
				const { data } = await ecAxios.connection().post(url, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				});
				if (!data.error) {
					this.getFullDetailsComponent(componentId);
					this.$toast.success(data.message, this.errorToastOptions);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		isExpired(dtFim, dtInicio) {
			const now = new Date();
			const dtFimDate = new Date(dtFim);
			const dtInicioDate = new Date(dtInicio);
			if (dtInicioDate > now) {
				return 'not-started';
			}
			if (dtFimDate < now) {
				return 'expired';
			}
			return 'active';
		},
		isEmptyObject(obj) {
			if (!obj) return true;
			return Object.keys(obj).length === 0 && obj.constructor === Object;
		},
		onRowClick(event) {
			const { row } = event;

			const copy = { ...row };

			copy.dt_inicio = this.parseToInputDatetimeLocal(copy.dt_inicio);
			copy.dt_fim = this.parseToInputDatetimeLocal(copy.dt_fim);
			this.rowSelected = copy;
		},
		async updateProductDetails(productSelected, componentId) {
			this.updateProductDetailsLoading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_PRODUTO_UPDATE}`;
				const params = {
					...productSelected,
				};

				const { data } = await ecAxios.connection().post(url, params);
				if (!data.error) {
					this.$toast.success(data.message, this.errorToastOptions);
					this.getFullDetailsComponent(componentId);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
			this.updateProductDetailsLoading = false;
		},
		async updateCategoriaDetails(categoriaSelected, componentId) {
			try {
				const requestData = {
					categorias: this.componente.componente_categorias.map((categoria, index) => {
						categoria.ordem = index + 1;
						return categoria;
					}),
				};
				// requestData.dt_inicio = requestData.dt_inicio === '~' ? '' : requestData.dt_inicio;
				// requestData.dt_fim = requestData.dt_fim === '~' ? '' : requestData.dt_fim;
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_CATEGORIA_UPDATE}`;
				const params = {
					...requestData,
				};

				const { data } = await ecAxios.connection().post(url, params);
				if (!data.error) {
					this.$toast.success(data.message, this.errorToastOptions);
					this.getFullDetailsComponent(componentId);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		// Clear input type file and preview
		clearInputFile() {
			// eslint-disable-next-line no-param-reassign
			/* eslint-disable */

			this.previewFiles = {
				desktop: {
					src: null,
					name: null,
					size: null,
				},

				tablet: {
					src: null,
					name: null,
					size: null,
				},
				smartphone: {
					src: null,
					name: null,
					size: null,
				},
			};

			this.selectedFiles = [];
		},
		clearImageInput(ref) {
			this.$refs[ref] = '';
			this.previewFiles[ref] = {
				src: null,
				name: null,
				size: null,
			};
		},

		async deleteImageDevice(componenteImagemId) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_IMAGEM_TAMANHO_DELETE}/${componenteImagemId}`;
				const { data } = await ecAxios.connection().delete(url);
				if (!data.error) {
					this.getFullDetailsComponent(this.componente.componente_id);
					this.$toast.success(data.message, this.errorToastOptions);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message.message, this.errorToastOptions);
			}
		},

		async onSearchProduct(key) {
			key = this.searchProductText || '';

			if (!key) {
				this.$toast.error(
					'Você precisa digitar um termo para pesquisar...',
					this.errorToastOptions
				);
				return;
			}

			this.searchProductLoading = true;

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTOS_SHOWALL}`;
				const { data } = await ecAxios.connection().post(url, {
					searchterm: key,
					// limit: 50,
				});
				if (!data.error) {
					this.searchProdutos = data.produtos;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message.message, this.errorToastOptions);
			}

			this.searchProductLoading = false;
		},
		async onSearchCategoria() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.CATEGORIAS_SHOWALL}`;
				const { data } = await ecAxios.connection().post(url, {
					// nivel: 1,
					status: 1,
					hasProduto: true,
					searchTerm: this.searchCategoriaText,
				});
				if (!data.error) {
					const { categorias } = data;

					categorias.map((categoria) => {
						// eslint-disable-next-line no-param-reassign
						// produto.src = `https://img.dpcnet.com.br/catalogo/${produto.integracao_id}.png`;
						return categoria;
					});

					this.searchCategorias = data.categorias;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message.message, this.errorToastOptions);
			}
		},

		// Create new order of images
		updateImageOrder(evt) {
			if (evt.moved) {
				this.componente.imagens = this.componente.imagens.map((image, index) => {
					// eslint-disable-next-line no-param-reassign
					image.ordem = index + 1;
					return image;
				});
			}
		},
		// Create new array of imagem_id and order to send to server
		async sendNewImageOrder() {
			this.sendNewImageOrderLoading = true;
			try {
				const newImageOrder = this.componente.imagens.map((image) => ({
					imagem_id: image.imagem_id,
					ordem: image.ordem,
				}));
				const params = {
					imagens: newImageOrder,
				};

				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_IMAGEM_UPDATE_ORDER}`;

				const { data } = await ecAxios.connection().put(url, params);

				if (!data.error) {
					this.$toast.success(data.message, this.errorToastOptions);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message.message, this.errorToastOptions);
			}
			this.sendNewImageOrderLoading = false;
		},
		toggleCheckAllProducts(isChecked) {
			if (isChecked) {
				this.addProdutoData.produto_id = [];
			} else {
				this.searchProdutos.forEach((element) => {
					this.addProdutoData.produto_id.push(element.integracao_id);
				});
			}
		},
		selectProduto(produto) {
			if (this.addProdutoData.produto_id.includes(produto.integracao_id)) {
				this.addProdutoData.produto_id = this.addProdutoData.produto_id.filter(
					(produtoId) => produtoId !== produto.integracao_id
				);
				return;
			}
			this.addProdutoData.produto_id.push(produto.integracao_id);
		},

		selectCategoria(categoria) {
			if (this.addCategoriaData.categoria_id.includes(categoria.id)) {
				this.addCategoriaData.categoria_id = this.addCategoriaData.categoria_id.filter(
					(categoriaId) => categoriaId !== categoria.id
				);
				return;
			}
			this.addCategoriaData.categoria_id.push(categoria.id);
		},

		// Create update component method
		async updateComponent(componente) {
			this.isLoadingUpdateComponent = true;

			if (!componente.dtinicio || componente.dtinicio == '~') componente.dtinicio = null;
			if (!componente.dtfim || componente.dtfim == '~') componente.dtfim = null;

			try {
				if (componente.descricao) {
					const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_UPDATE}/${componente.componente_id}`;
					const { data } = await ecAxios.connection().put(url, componente);
					if (!data.error) {
						this.$toast.success(data.message, this.errorToastOptions);
						this.getFullDetailsComponent(componente.componente_id);
					} else {
						throw new Error(data.message);
					}
				}
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
			}
			this.isLoadingUpdateComponent = false;
		},
		// Update image details method
		async updateImageDetails(imagem, componenteId) {
			this.isLoadingUpdateImageDetails = true;
      if(imagem.plataforma.length === 0) {
        this.$toast.warning('Você precisa selecionar uma plataforma', this.errorToastOptions);
        this.isLoadingUpdateImageDetails = false;
        return;
      }

      if(imagem.plataforma.length > 0 && imagem.plataforma.includes('mobile')) {
        imagem.plataforma = imagem.plataforma.filter((item) => item !== 'mobile');
        imagem.plataforma.push('android-app', 'ios-app');
      }

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_UPDATE}/${componenteId}/imagem/${imagem.imagem_id}`;
				const { data } = await ecAxios.connection().put(url, imagem);
				if (!data.error) {
					this.$toast.success(data.message, this.errorToastOptions);
					this.getFullDetailsComponent(this.componente.componente_id);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
			}
			this.isLoadingUpdateImageDetails = false;
		},
		getImageDesc(tipo) {
			switch (tipo) {
				case 'D':
					return 'Desktop';
				case 'T':
					return 'Tablet';
				case 'M':
					return 'Smartphone';
				default:
					return 'Desktop';
			}
		},
		// Get image by type
		getImageByType(imagens, tipo) {
			const img = imagens.find((imagem) => imagem.tipo === tipo);
			if (img) {
				return img;
			}
			return {
				nome_img: 'imagem_indisponivel.jpg',
			};
		},
		async addProdutoComponente() {
			if (!this.addProdutoData.produto_id.length) {
				this.$toast.warning('Você precisa selecionar um produto', this.errorToastOptions);
				return;
			}
			if (!this.addProdutoData.ordem) {
				this.$toast.warning('Você precisa escolher uma ordem', this.errorToastOptions);
				return;
			}
			if (!this.checkProductOrder(this.addProdutoData.ordem)) {
				this.$toast.warning('Esta ordem não está disponível', this.errorToastOptions);
				return;
			}

			if (!this.addProdutoData.dt_inicio) delete this.addProdutoData.dt_inicio;
			if (!this.addProdutoData.dt_fim) delete this.addProdutoData.dt_fim;

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_PRODUTO_ADD}/${this.componente.componente_id}`;
				const { data } = await ecAxios.connection().post(url, this.addProdutoData);
				if (!data.error) {
					this.addProdutoData = {
						produto_id: [],
						dt_inicio: '',
						dt_fim: '',
						ordem: '',
					};
					this.addProdutoModal = false;
					this.$toast.success(data.message, this.errorToastOptions);
					this.getFullDetailsComponent(this.componente.componente_id);
				} else if (data.error == 404) {
					this.addProdutoData = {
						produto_id: [],
						dt_inicio: '',
						dt_fim: '',
						ordem: '',
					};
					this.getFullDetailsComponent(this.componente.componente_id);
					throw new Error(data.message);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
			}
		},

		async addCategoriaComponente() {
			this.isLoadingAdicionarCategoria = true;
			if (!this.addCategoriaData.categoria_id.length) {
				this.$toast.warning('Você precisa selecionar uma categoria', this.errorToastOptions);
				return;
			}
			// if (!this.addCategoriaData.ordem) {
			// 	this.$toast.warning('Você precisa escolher uma ordem', this.errorToastOptions);
			// 	return;
			// }
			// if (!this.checkProductOrder(this.addCategoriaData.ordem)) {
			// 	this.$toast.warning('Esta ordem não está disponível', this.errorToastOptions);
			// 	return;
			// }

			if (!this.addCategoriaData.dt_inicio) delete this.addCategoriaData.dt_inicio;
			if (!this.addCategoriaData.dt_fim) delete this.addCategoriaData.dt_fim;

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_CATEGORIA_ADD}/${this.componente.componente_id}`;
				const { data } = await ecAxios.connection().post(url, this.addCategoriaData);
				if (!data.error) {
					this.addCategoriaData = {
						categoria_id: [],
						dt_inicio: '',
						dt_fim: '',
						ordem: '',
					};
					this.addCategoriaModal = false;
					this.$toast.success(data.message || '', this.errorToastOptions);
					this.getFullDetailsComponent(this.componente.componente_id);
				} else if (data.error == 404) {
					this.addCategoriaData = {
						categoria_id: [],
						dt_inicio: '',
						dt_fim: '',
						ordem: '',
					};
					this.getFullDetailsComponent(this.componente.componente_id);
					throw new Error(data.message);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.warning(
					error.message || 'Erro ao adicionar categoria.',
					this.errorToastOptions
				);
			}
			this.isLoadingAdicionarCategoria = false;
		},

		async checkProductOrder(ordem) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_PRODUTO_CHECK_ORDER}/${this.componente.componente_id}/${ordem}`;
				const { data } = await ecAxios.connection().get(url);
				if (!data.error) {
					return data.isAvailable;
				}
				throw new Error(data.message);
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
				return false;
			}
		},
		async submitFile(event) {
			this.uploadLoading = true;
			if (event.target.titulo && event.target.titulo.value === '') {
				this.$toast.warning('Preencha o campo titulo', this.errorToastOptions);
        this.uploadLoading = false;
				return;
			}
			if (event.target.dtinicio && event.target.dtinicio.value === '') {
				this.$toast.warning('Preencha o campo data de inicio', this.errorToastOptions);
                this.uploadLoading = false;
				return;
			}
			if (event.target.dtfim && event.target.dtfim.value === '') {
				this.$toast.warning('Preencha o campo data fim', this.errorToastOptions);
                this.uploadLoading = false;
				return;
			}

      if(this.selectedFiles.length === 0) {
        this.$toast.warning('Selecione pelo menos uma imagem', this.errorToastOptions);
        this.uploadLoading = false;
        return;
      }

      if(this.platformValue.length === 0) {
        this.$toast.warning('Selecione pelo menos uma plataforma', this.errorToastOptions);
        this.uploadLoading = false;
        return;
      }

      if(this.platformValue.includes('web') && !this.selectedFiles[0]) {
        this.$toast.warning('Selecione pelo menos uma imagem para desktop', this.errorToastOptions);
        this.uploadLoading = false;
        return;
      }

      if(this.platformValue.includes('mobile') || this.platformValue.includes('android-app') || this.platformValue.includes('ios-app')) {
        if(!this.selectedFiles[1] && !this.selectedFiles[2]) {
          this.$toast.warning('Selecione pelo menos uma imagem para mobile', this.errorToastOptions);
          this.uploadLoading = false;
          return;
        }
      }

      if(this.platformValue.includes('mobile')) {
        this.platformValue = this.platformValue.filter((item) => item !== 'mobile');
        this.platformValue.push('android-app', 'ios-app');
      }

			const componentId = this.$route.params.id;
			const formData = new FormData();
			formData.append('titulo', event.target.titulo.value);
			formData.append('link', event.target.link.value);
			formData.append('dt_inicio', event.target.dt_inicio.value);
			formData.append('dt_fim', event.target.dt_fim.value);
			formData.append('imagem_desktop', this.selectedFiles[0] || null);
			formData.append('imagem_tablet', this.selectedFiles[1] || null);
			formData.append('imagem_smartphone', this.selectedFiles[2] || null);
      formData.append('plataforma', this.platformValue.join(','));
			formData.append('componente_id', componentId);

			const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_UPLOAD_IMAGE}`;

			try {
				const { data } = await ecAxios.connection().post(url, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				});
				if (!data.error) {
					this.showModal = !this.showModal;
					this.$refs.formUpload.reset();
					this.clearInputFile();
					this.getFullDetailsComponent(componentId);

					this.$toast.success(data.message, this.errorToastOptions);
				} else {
					this.$toast.error(data.error, this.errorToastOptions);
					throw new Error(data.message);
				}
			} catch (error) {
        const message = error?.response?.data?.message || error.message;
				this.$toast.error(message, this.errorToastOptions);
			}
			this.uploadLoading = false;
		},
		onSubmit(e) {
			e.preventDefault();
		},
		selectImage(refIndex) {
			this.$refs['img-item'].map((item, index) => {
				if (index === refIndex) {
					item.classList.add('img-selected');
				} else {
					item.classList.remove('img-selected');
				}
				return item;
			});

			const img = { ...this.componente.imagens[refIndex] };
			img.dt_inicio = this.parseToInputDatetimeLocal(img.dt_inicio);
			img.dt_fim = this.parseToInputDatetimeLocal(img.dt_fim);
			this.imageSelected = img;
		},
		getFileData(event, type) {
			const [file] = event.target.files;
			switch (type) {
				case 'D':
					this.previewFiles.desktop.src = URL.createObjectURL(file);
					this.selectedFiles[0] = file;
					break;
				case 'T':
					this.previewFiles.tablet.src = URL.createObjectURL(file);
					this.selectedFiles[1] = file;
					break;
				case 'S':
					this.previewFiles.smartphone.src = URL.createObjectURL(file);
					this.selectedFiles[2] = file;
					break;
				default:
					break;
			}
		},
		async dialogFunction(data) {
			this.deleteImage(this.imageSelected.imagem_id);
		},
		async deleteImage(imageId) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_IMAGEM_DELETE}/${imageId}`;
				const { data } = await ecAxios.connection().delete(url);
				const componentId = this.$route.params.id;
				if (componentId) {
					this.getFullDetailsComponent(componentId);
				}
				if (!data.error) {
					this.$toast.success(data.message, this.errorToastOptions);
				} else {
					this.$toast.error(data.error, this.errorToastOptions);
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
			this.showDialog = !this.showDialog;
		},
		returnValidImages(images) {
			const validImagens = [];
			images.forEach((imagem) => {
				if (imagem.isValid) {
					validImagens.push(imagem);
				}
			});
			return validImagens;
		},
		async getFullDetailsComponent(componentId) {
			if (!componentId) return;
			this.isFullDetailLoading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_FULL_DETAILS}/${componentId}?produtos=true&categorias=true`;
				const { data } = await ecAxios.connection().get(url);
				if (!data.error) {
					this.imageSelected = null;
					// eslint-disable-next-line prefer-destructuring

					this.componente = [];

					if (data.componentes[0]) {
						this.componente = data.componentes[0];
						this.componente.dtinicio = this.parseToInputDatetimeLocal(this.componente.dtinicio);
						this.componente.dtfim = this.parseToInputDatetimeLocal(this.componente.dtfim);
					}

					this.componente.imagens.map((imagem) => {
						// eslint-disable-next-line no-param-reassign
						imagem.selected = false;
						// eslint-disable-next-line no-param-reassign
						imagem.isValid = this.isExpired(imagem.dt_fim, imagem.dt_inicio) === 'active';
						return imagem;
					});
					this.componente.produtos.map((produto) => {
						// eslint-disable-next-line no-param-reassign
						produto.acoes = '';
						return produto;
					});

					this.newImageOrder = this.componente.imagens;
					this.isFullDetailLoading = false;
				} else throw new Error(data.error);
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},

		handleSelectSheetName(sheetIndex) {
			if (this.sheetsSelected.includes(sheetIndex)) {
				this.sheetsSelected = this.sheetsSelected.filter((sheetId) => sheetId != sheetIndex);

				return;
			}

			this.sheetsSelected.push(sheetIndex);
		},

		handleImportFile(e) {
			this.cleanOnCloseModal();

			readXlsxFile(e.target.files[0], { getSheets: true })
				.then(async (sheets) => {
					if (!sheets.length) {
						this.$toast.warning(
							'Não foram encontrados dados para importação, tente novamente',
							this.errorToastOptions
						);
						return;
					}

					this.sheetsFound = sheets;
					this.activeSheet = e.target.files[0];
				})
				.catch((e) => {
					console.error(e);
					this.$toast.error(
						'Arquivo de importação invalido, tente novamente',
						this.errorToastOptions
					);
				});
		},
		async handleAddProductsImported() {
			if (!this.sheetsSelected.length) {
				this.$toast.warning(
					'Você deve selecionar ao menos uma lista para fazer a importação!',
					this.errorToastOptions
				);
				return;
			}

			let produtos = [];

			const schema = {
				EAN: {
					prop: 'ean',
					required: true,
				},
				cod_produto: {
					prop: 'cod_produto',
					required: true,
				},
				id_integracao: {
					prop: 'id_integracao',
					required: true,
				},
			};

			for (const sheetId of this.sheetsSelected) {
				let produtosAux = await readXlsxFile(this.activeSheet, {
					sheet: sheetId,
					schema,
				}).then(({ rows, errors }) => {
					if (!rows.length) {
						this.$toast.warning(
							'Não foram encontrados dados para importação, tente novamente',
							this.errorToastOptions
						);
						return;
					}

					let produtosAux = [];
					rows.forEach((item) => {
						if (item.ean) produtosAux.push(item.ean);
						if (item.cod_produto) produtosAux.push(item.cod_produto);
						if (item.id_integracao) produtosAux.push(item.id_integracao);
					});

					return produtosAux;
				});

				produtos = [...produtos, ...produtosAux];
			}

			produtos = produtos.reduce(function (a, b) {
				if (a.indexOf(b) < 0) a.push(b);
				return a;
			}, []);

			let produtosAux = [];
			produtos.forEach((produto) => {
				if (produto) produtosAux.push({ produtoId: produto });
			});

			this.productsImported = produtosAux;

			const productsAux = this.productsImported.map((product) => product.produtoId);

			this.addProdutoData.produto_id = productsAux;

			this.cleanOnCloseModal();
			this.importProdutoModal = false;
			this.importCategoriaModal = false;

			this.addProdutoComponente();
		},

		cleanOnCloseModal() {
			this.productsImported = [];
			this.categoriesImported = [];
			this.activeSheet = {};
			this.sheetsSelected = [];
			this.sheetsFound = [];
		},
	},
};
</script>

<style scoped lang="scss">
@import '~@/style/Global.css';

.platforms-icons {
  background-color: #FFF;
  padding: 2.5px 5px;
  bottom: 0;
  right: 0;
  border-top-left-radius: 6px;
}

.input-upload-modal {
    border: 1px solid #e2eaf5;
    border-radius: 6px;
    height: 36px;
}
.sheetContent {
	border: 1px solid #e2eaf5;
	transition: var(--default-transition);
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	width: 32%;
	padding: 5px;
	font-size: 13px;
	font-weight: 500;

	input {
		position: relative;
		top: -1px;
		cursor: pointer;
		margin-right: 5px;
	}

	&.selected,
	&:hover {
		border: solid 1px #09af4f;
		box-shadow: var(--default-shadow);
	}

	label {
		text-transform: capitalize;
		cursor: pointer;
		margin: 0px;
	}
}

.select-container {
	all: unset;
	cursor: pointer;
	border: 1px solid #e2eaf5;
	padding: 3px;
	border-radius: 4px;
}

.loader-icon {
	animation: is-rotating 1s infinite;
	border: 2px solid #cecece;
	width: 14px;
	border-top-color: #ff3b30;
	border-radius: 50%;
	height: 14px;
}

@keyframes is-rotating {
	to {
		transform: rotate(1turn);
	}
}

section {
	display: flex;
}
.finish-box {
	width: 100%;
	height: 50px;
	padding: 5px;
	background-color: #fb8500;
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
	h1 {
		font-size: 12px;
		font-weight: bold;
		color: #fff;
	}
}

.init-box {
	width: 100%;
	height: 50px;
	padding: 5px;
	background-color: #09af5f;
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
	h1 {
		font-size: 12px;
		font-weight: bold;
		color: #fff;
	}
}

.produto-imagem {
	width: 100%;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		padding: 5px;
		height: 100%;
	}
}
.input-group-custom {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;

	.input-group-item:nth-child(1) {
		width: 35%;
	}
	.input-group-item:nth-child(2) {
		width: 35%;
	}
	.input-group-item:nth-child(3) {
		width: 20%;
	}
}

.produto-item {
	padding: 10px;
	transition: var(--default-transition);
	cursor: pointer;
	display: flex;
	margin-right: 5px;
	margin-top: 10px;
	margin-bottom: 10px;
	border-radius: 3px;
	width: 32%;
	border: 1px solid #e2eaf5;
	flex: 1 1 220px;

	&:hover {
		border: 1px solid #09af5f;
		box-shadow: var(--default-shadow);
	}
	.descricao {
		margin-top: 10px;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 5px;
	}
	.produto-info {
		font-size: 10px;
		display: flex;
		flex-direction: column;
	}
}

.titulo-box {
	font-size: 16px;
	font-weight: bold;
}

.selected {
	border: 1px solid #09af5f;
	box-shadow: var(--default-shadow);
}

.container-produto {
	margin-top: 20px;
	max-width: 100%;
	height: calc(100vh - 400px);
	max-height: 550px;
	flex-wrap: wrap;
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	overflow-x: auto;
}
.empty-box {
	background-color: #fff;
}
.trash-icon {
	justify-self: flex-start;
	align-self: flex-end;
	height: inherit;
	z-index: 1;
	margin-top: 15px;
	margin-right: -5px;
	position: absolute;
	&:hover {
		color: #c70505;
		cursor: pointer;
	}
}
.device-label {
	font-size: 12px;
	border-bottom: 1px solid #e2eaf5;
}

.box-div {
	margin-top: 30px;
	margin-bottom: 30px;
}
.label-input {
	font-size: 12px;
	font-weight: bold;
	color: #666666;
	margin-top: 10px;
	margin-bottom: 3px;
}
.input-custom {
	border: 1px solid #e2eaf5;
	padding: 3px;
	border-radius: 4px;
}
.dica {
	font-size: 12px;
	padding: 5px;
	margin-top: 5px;
	border-radius: var(--default-border-radius);
	color: #28c76f;
	background-color: #28c76f1f;

	&.alert {
		color: #dfa108;
		background-color: #ffb70314;
	}
}

.img-preview {
	max-width: 100%;
	max-height: 100%;
	background-position: center;
	background-repeat: no-repeat;
	justify-self: center;
	align-self: center;
}
.desktop,
.smartphone,
.tablet {
	width: 27%;
	height: 150px;
	border: 1px dashed #e5e5e5;
	padding: 10px;
	border-radius: var(--default-border-radius);
	position: relative;
}
.desktop {
    &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
}

.edit-icon {
	cursor: pointer;
	transition: all 0.3s ease-in-out;
}
#delete-image {
	margin-left: 5px;
	&:hover {
		color: #c70505;
	}
}
.edit-icon {
	&:nth-child(1) {
		&:hover {
			color: #09af5f;
		}
	}
}

.upload-cloud {
	color: #ff8800;
}
.input-label {
	font-size: 12px;
	font-weight: bold;
	color: #666666;
}

.input-edit-image-D,
.input-edit-image-M,
.input-edit-image-T {
	display: none;
}

.label-edit-icon {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: 0;
	margin: 0;
}

.btn-steps,
.btn-produto {
	all: unset;
	font-size: 10px;
	text-transform: uppercase;
	padding: 5px;
	width: 150px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 3px;
	font-weight: bold;
	color: #fff;
	transition: ease-in-out 0.3s;
}
.next {
	background-color: var(--primary-color);
}
.next:hover {
	cursor: pointer;
	background-color: darken(#09af5f, 10%);
}
.back {
	background-color: red;
}
.back:hover {
	cursor: pointer;
	background-color: darken(red, 10%);
}
.label-upload {
	cursor: pointer;
	border: 1px dashed #ccc;
}

.list-group-flush {
	max-height: 173px;
	overflow-x: auto;
}

.img-text {
	font-weight: bold;
	font-size: 14px;
}
.list-group-item {
	border-radius: 4px;
	margin-top: 10px;
	padding: 10px;
}
.box-image-upload {
	width: 100%;
}
.list-group-item p {
	white-space: nowrap;
	overflow: hidden;
	font-size: 12px;
	color: #000;
	text-overflow: ellipsis;
	text-overflow: '...';
}

.img-selected {
	opacity: 0.8;
}
.container-image-responsively {
	width: 100%;
	margin-top: 10px;
	img {
		width: 100%;
	}
}

.icon-delete {
	color: #fff;
	display: flex;
}
.container-icon {
	display: none;
	z-index: 1;
	width: 30px;
	height: 30px;
	background-color: #c70505;
}
.container-icon:hover {
	background-color: darken(#c70505, 10%);
}
.image-draggable:hover .container-icon {
	display: flex;
}
.image-draggable {
	width: 32%;
	max-height: 150px;
	border: var(--default-border);
	display: flex;
	cursor: move;
	border-radius: var(--default-border-radius);
	transition: ease-in-out 0.3s;

	img {
		display: flex;
		background-size: cover;
		object-fit: scale-down;
		background-position: center;
		align-self: center;
		justify-self: center;
		background-repeat: no-repeat;
		height: 100%;
	}
}
.right-side {
	width: 22%;
	height: fit-content;
	.image-details {
		margin-bottom: 10px;
	}
}
.slick-next,
.slick-prev {
	border-radius: 10px;
}
.left-side {
	width: 75%;
	margin-right: 30px;
	box-sizing: border-box;
}

.box-left {
	background-color: var(--white-color);
	border-radius: 4px;
}
.box-right {
	background-color: var(--white-color);
	border-radius: 4px;
}

.container-imagens {
	background-color: var(--white-color);
	padding: 30px;
}

.box__file {
	display: none;
}

.fileAddButton {
	input {
		display: none;
	}
	label {
		cursor: pointer;
		font-size: 10px;
		background-color: rgb(255, 136, 0);
		border-radius: 3px;
		color: rgb(255, 255, 255);
		width: 150px;
		height: 40px;
		border-width: 1px;
		border-style: solid;
		border-color: rgb(206, 206, 206);
		display: flex;
		align-items: center;
		font-family: Sora, sans-serif !important;
		font-weight: bold;
		justify-content: center;
		letter-spacing: 0px;
		margin-left: 0px;
		margin-right: 0px;
	}
}
</style>

